import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AngularFireDatabase } from 'angularfire2/database';
import swal from 'sweetalert2';
import * as firebase from'firebase/app';
import { fadeInOutTranslate } from 'app/shared/elements/animation';
import { NotificationToastService } from 'app/notification/notification-toast.service';
declare var google;
@Component({
  selector: 'app-cities',
  templateUrl: './cities.component.html',
  styleUrls: ['./cities.component.css'],
  providers:[NotificationToastService, AngularFireDatabase],
  animations: [fadeInOutTranslate]
})
export class CitiesComponent implements OnInit {
  myForm: FormGroup;
  submitted: boolean = false;
  lat:any;
  lng:any;
  public sortOrder: string = "desc";
  public sortBy: string = "";
  public data: any;
  public rowsOnPage: number = 10;
  public filterQuery: string = "";
  constructor(private db: AngularFireDatabase, private nf: NotificationToastService) {
    this.initializeForm();
   }

  ngOnInit() {
    const d = this.db.list('cities');
    this.db.list('cities').snapshotChanges().subscribe(cities=>{
      this.data = [];
      cities.forEach(d=>{
        var y = d.payload.toJSON();
        y["$key"] = d.key;
        this.data.push(y);
      });
    });
  }
  initializeForm()
  {
    this.myForm = new FormGroup({
      cityName: new FormControl('', Validators.required),
      pincode: new FormControl('', Validators.required),
      latitude: new FormControl('', Validators.required),
      longitude: new FormControl('', Validators.required)
    });
  }
  getLatLngFromPincode(address)
{;
    var geocoder = new google.maps.Geocoder();
    geocoder.geocode({ 'address': address }, (results, status) =>{
      if (status == google.maps.GeocoderStatus.OK) {
            this.lat = results[0].geometry.location.lat();
            this.lng = results[0].geometry.location.lng();
            //console.log("lat lng ", this.lat, this.lng);
      } else {
          alert("Enter valid pincode.");
          this.lat = null;
          this.lng = null;
      }
  });
}
onSubmit()
{
  this.submitted = true;
  if(this.myForm.valid)
  {
    //console.log(this.myForm.value);
      firebase.database().ref("cities").push({
        name : this.myForm.value.cityName,
        pincode: this.myForm.value.pincode,
        lat: this.myForm.value.latitude,
        lng: this.myForm.value.longitude
      }).then(()=>{
        this.myForm.reset();
        this.submitted = false;
        this.nf.addToast({title:'City Added', msg:'New City has been added', timeout: 5000, theme:'material', position:'bottom-right', type:'success'});
      });
  }
  }
  delete(id) {
    //console.log("delete");
    this.findCityExists(id);
  }
  findCityExists(id)
  {
    firebase.database().ref("shipments").on("value",(data)=>{
     var shipments = data.val();
     var exists = 0;
     for(let i in shipments)
     {
       if(shipments[i].source.cityId == id || shipments[i].source.cityId == id)
       {
         exists++;
       }
     }
     if(exists > 0)
     {
      alert("City is associated with Shipment");
     }
     else
     {
      swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then(() => {
        this.db.object('/cities/'+id).remove();
        swal({
          title:'Deleted!',
          text: 'Your file has been deleted.',
          type: 'success'
        })
      }).catch(swal.noop);
     }
    });
  }
  refresh()
  {
    this.sortBy = "";
    this.filterQuery = "";
  }
}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/logistics-operations/cities/cities.component.ts